// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { DeleteUserData, DeleteUserResponses, GetUserByIdData, GetUserByIdResponses, UpdateUserData, UpdateUserResponses, TenantDeleteWebhookData, TenantDeleteWebhookResponses, TenantGetWebhookData, TenantGetWebhookResponses, TenantUpdateWebhookData, TenantUpdateWebhookResponses, DeleteMyTemplateData, DeleteMyTemplateResponses, GetMyTemplateByIdData, GetMyTemplateByIdResponses, UpdateMyTemplateData, UpdateMyTemplateResponses, DeleteMySignatureData, DeleteMySignatureResponses, GetMySignatureByIdData, GetMySignatureByIdResponses, UpdateMySignatureData, UpdateMySignatureResponses, UpdateSectionData, UpdateSectionResponses, TenantGetProfileData, TenantGetProfileResponses, TenantUpdateProfileData, TenantUpdateProfileResponses, TenantProfileDeleteApiKeyData, TenantProfileDeleteApiKeyResponses, TenantProfileUpdateApiKeyData, TenantProfileUpdateApiKeyResponses, GetAdminProfileData, GetAdminProfileResponses, UpdateAdminProfileData, UpdateAdminProfileResponses, TenantDeleteApiKeyData, TenantDeleteApiKeyResponses, TenantGetApiKeyData, TenantGetApiKeyResponses, TenantUpdateApiKeyData, TenantUpdateApiKeyResponses, TenantUpdateApiKeyStatusData, TenantUpdateApiKeyStatusResponses, DeleteUser1Data, DeleteUser1Responses, DeleteUser1Errors, GetUserDetailData, GetUserDetailResponses, GetUserDetailErrors, UpdateUser1Data, UpdateUser1Responses, UpdateUser1Errors, UpdateUserStatusData, UpdateUserStatusResponses, GetUserRolesData, GetUserRolesResponses, AssignUserRolesData, AssignUserRolesResponses, UpdateTenantStatusData, UpdateTenantStatusResponses, UpdateTenantStatusErrors, AdminUpdateCertificationStatusData, AdminUpdateCertificationStatusResponses, UpdateApiKeyStatusData, UpdateApiKeyStatusResponses, UpdateSignatureStatusData, UpdateSignatureStatusResponses, UpdateSpecificOperatorReportData, UpdateSpecificOperatorReportResponses, UpdateOperatorReportStatusData, UpdateOperatorReportStatusResponses, DeleteData, DeleteResponses, GetByIdData, GetByIdResponses, UpdateData, UpdateResponses, GetProtocolConfigData, GetProtocolConfigResponses, UpdateProtocolConfigData, UpdateProtocolConfigResponses, DeleteMobileLocationData, DeleteMobileLocationResponses, UpdateMobileLocationData, UpdateMobileLocationResponses, DeleteFrequencyRuleData, DeleteFrequencyRuleResponses, UpdateFrequencyRuleData, UpdateFrequencyRuleResponses, DeleteKeywordData, DeleteKeywordResponses, UpdateKeywordData, UpdateKeywordResponses, DeleteChannelData, DeleteChannelResponses, GetChannelData, GetChannelResponses, UpdateChannelData, UpdateChannelResponses, GetUsersData, GetUsersResponses, CreateUserData, CreateUserResponses, ToggleUserLockData, ToggleUserLockResponses, ResetPasswordData, ResetPasswordResponses, GetWhitelistData, GetWhitelistResponses, AddToWhitelistData, AddToWhitelistResponses, BatchAddToWhitelistData, BatchAddToWhitelistResponses, TenantGetWebhooksData, TenantGetWebhooksResponses, TenantCreateWebhookData, TenantCreateWebhookResponses, TenantTestWebhookData, TenantTestWebhookResponses, GetMyTemplatesData, GetMyTemplatesResponses, CreateMyTemplateData, CreateMyTemplateResponses, ExportUplinkData, ExportUplinkResponses, TenantSendSmsData, TenantSendSmsResponses, TenantExportSmsRecordsData, TenantExportSmsRecordsResponses, GetMySignaturesData, GetMySignaturesResponses, CreateMySignatureData, CreateMySignatureResponses, TenantSubmitCertificationData, TenantSubmitCertificationResponses, TenantProfileGetApiKeysData, TenantProfileGetApiKeysResponses, TenantProfileCreateApiKeyData, TenantProfileCreateApiKeyResponses, TenantProfileRegenerateApiKeyData, TenantProfileRegenerateApiKeyResponses, CheckContentData, CheckContentResponses, GetBlacklistData, GetBlacklistResponses, AddToBlacklistData, AddToBlacklistResponses, BatchAddToBlacklistData, BatchAddToBlacklistResponses, ExportBillingData, ExportBillingResponses, TenantGetApiKeysData, TenantGetApiKeysResponses, TenantCreateApiKeyData, TenantCreateApiKeyResponses, SelfRechargeData, SelfRechargeResponses, SendSmsData, SendSmsResponses, QueryBatchSmsStatusData, QueryBatchSmsStatusResponses, CancelSmsData, CancelSmsResponses, BatchSendSmsData, BatchSendSmsResponses, GetRolesData, GetRolesResponses, CreateRoleData, CreateRoleResponses, RegisterTenantData, RegisterTenantResponses, ValidateApiKeyData, ValidateApiKeyResponses, ValidateApiKeyWithSignatureData, ValidateApiKeyWithSignatureResponses, RecordApiKeyUsageData, RecordApiKeyUsageResponses, TenantRegisterData, TenantRegisterResponses, TenantLoginData, TenantLoginResponses, RefreshTokenData, RefreshTokenResponses, LogoutData, LogoutResponses, AdminLoginData, AdminLoginResponses, GetWhitelist1Data, GetWhitelist1Responses, AddWhitelistData, AddWhitelistResponses, GetUsers1Data, GetUsers1Responses, GetUsers1Errors, CreateUser1Data, CreateUser1Responses, CreateUser1Errors, ToggleUserLock1Data, ToggleUserLock1Responses, ResetPassword1Data, ResetPassword1Responses, ResetPassword1Errors, GetTenantsData, GetTenantsResponses, GetTenantsErrors, CreateTenantData, CreateTenantResponses, CreateTenantErrors, RechargeTenantData, RechargeTenantResponses, RechargeTenantErrors, SubmitCertificationForTenantData, SubmitCertificationForTenantResponses, ApproveCertificationData, ApproveCertificationResponses, ApproveTenantData, ApproveTenantResponses, CreateTenantWithApprovalData, CreateTenantWithApprovalResponses, ReviewTemplateData, ReviewTemplateResponses, ReviewSignatureData, ReviewSignatureResponses, GetSensitiveWordsData, GetSensitiveWordsResponses, AddSensitiveWordData, AddSensitiveWordResponses, BatchImportSensitiveWordsData, BatchImportSensitiveWordsResponses, ListData, ListResponses, CreateData, CreateResponses, ExportUplink1Data, ExportUplink1Responses, IngestUplinkData, IngestUplinkResponses, IngestUplink1Data, IngestUplink1Responses, ExportReceiptsData, ExportReceiptsResponses, IngestReceiptData, IngestReceiptResponses, IngestReceipt1Data, IngestReceipt1Responses, ExportMessagesData, ExportMessagesResponses, ExportErrorsData, ExportErrorsResponses, ImportCsvData, ImportCsvResponses, GetMobileLocationsData, GetMobileLocationsResponses, CreateMobileLocationData, CreateMobileLocationResponses, QueryMobileLocationData, QueryMobileLocationResponses, ImportMobileLocationsData, ImportMobileLocationsResponses, GetFrequencyRulesData, GetFrequencyRulesResponses, CreateFrequencyRuleData, CreateFrequencyRuleResponses, GetKeywordsData, GetKeywordsResponses, AddKeywordData, AddKeywordResponses, CheckContent1Data, CheckContent1Responses, GetChannelPageData, GetChannelPageResponses, CreateChannelData, CreateChannelResponses, TestChannelData, TestChannelResponses, EnableChannelData, EnableChannelResponses, DisableChannelData, DisableChannelResponses, SelectChannelData, SelectChannelResponses, GetBlacklist1Data, GetBlacklist1Responses, AddBlacklistData, AddBlacklistResponses, GetUserStatisticsData, GetUserStatisticsResponses, GetCurrentUserData, GetCurrentUserResponses, TenantGetWebhookIntegrationGuideData, TenantGetWebhookIntegrationGuideResponses, TenantGetWebhookEventsData, TenantGetWebhookEventsResponses, TenantGetWebhookCategoriesData, TenantGetWebhookCategoriesResponses, ListUplinkData, ListUplinkResponses, StatsData, StatsResponses, TenantGetSmsRecordsData, TenantGetSmsRecordsResponses, TenantGetSmsStatusData, TenantGetSmsStatusResponses, TenantDownloadSmsExportData, TenantDownloadSmsExportResponses, GetApprovedSignaturesData, GetApprovedSignaturesResponses, GetSettingsData, GetSettingsResponses, RangeData, RangeResponses, MonthlyData, MonthlyResponses, TenantGetStatisticsData, TenantGetStatisticsResponses, TenantGetCertificationData, TenantGetCertificationResponses, GetCertificationRejectionReasonsData, GetCertificationRejectionReasonsResponses, TenantGetBalanceData, TenantGetBalanceResponses, TenantProfileGetApiKeyStatisticsData, TenantProfileGetApiKeyStatisticsResponses, TenantGetMoMessagesData, TenantGetMoMessagesResponses, TenantGetMoMessageData, TenantGetMoMessageResponses, TenantGetMoMessageStatsData, TenantGetMoMessageStatsResponses, CheckBlacklistData, CheckBlacklistResponses, ListBillingRecordsData, ListBillingRecordsResponses, DownloadBillingData, DownloadBillingResponses, GetBalanceData, GetBalanceResponses, GetTransactionsData, GetTransactionsResponses, GetAccountOverviewData, GetAccountOverviewResponses, TenantAccountBalanceData, TenantAccountBalanceResponses, GetTemplatesData, GetTemplatesResponses, GetTemplateDetailData, GetTemplateDetailResponses, GetSmsStatusData, GetSmsStatusResponses, GetSmsRecordsData, GetSmsRecordsResponses, QuerySmsStatusData, QuerySmsStatusResponses, GetAllPermissionsData, GetAllPermissionsResponses, CheckContactPhoneData, CheckContactPhoneResponses, CheckContactEmailData, CheckContactEmailResponses, CheckTenantCodeData, CheckTenantCodeResponses, GetApiKeyInfoData, GetApiKeyInfoResponses, HealthData, HealthResponses, DetailedHealthData, DetailedHealthResponses, GetFileData, GetFileResponses, ValidateTokenData, ValidateTokenResponses, GetCurrentUser1Data, GetCurrentUser1Responses, GetUserStatistics1Data, GetUserStatistics1Responses, GetTenantDetailData, GetTenantDetailResponses, GetTenantDetailErrors, GetTenantCertificationData, GetTenantCertificationResponses, GetCertificationRejectionReasons1Data, GetCertificationRejectionReasons1Responses, GetTenantApprovalHistoryData, GetTenantApprovalHistoryResponses, GetTenantApiKeysData, GetTenantApiKeysResponses, GetTenantAccountData, GetTenantAccountResponses, GetTenantAccountErrors, GetPendingApprovalTenantsData, GetPendingApprovalTenantsResponses, GetAllPendingApprovalsData, GetAllPendingApprovalsResponses, GetPlatformApiKeyStatisticsData, GetPlatformApiKeyStatisticsResponses, GetTemplates1Data, GetTemplates1Responses, DeleteTemplateData, DeleteTemplateResponses, GetTemplateByIdData, GetTemplateByIdResponses, GetSendTrendsData, GetSendTrendsResponses, GetTenantRankingData, GetTenantRankingResponses, GetSendStatsOverviewData, GetSendStatsOverviewResponses, GetChannelPerformanceData, GetChannelPerformanceResponses, GetRevenueTrendsData, GetRevenueTrendsResponses, GetRevenueStatsOverviewData, GetRevenueStatsOverviewResponses, GetRealtimeStatsData, GetRealtimeStatsResponses, GetPlatformOverviewData, GetPlatformOverviewResponses, GetSignaturesData, GetSignaturesResponses, DeleteSignatureData, DeleteSignatureResponses, GetSignatureByIdData, GetSignatureByIdResponses, GetOperatorReportsData, GetOperatorReportsResponses, GetSignaturesNeedingOperatorReportingData, GetSignaturesNeedingOperatorReportingResponses, GetSignaturesInOperatorReportingData, GetSignaturesInOperatorReportingResponses, GetSendTrends1Data, GetSendTrends1Responses, GetSendStatisticsData, GetSendStatisticsResponses, GetSendMonitoringData, GetSendMonitoringResponses, ListUplink1Data, ListUplink1Responses, DownloadUplinkData, DownloadUplinkResponses, ListReceiptsData, ListReceiptsResponses, DownloadReceiptsData, DownloadReceiptsResponses, ListMessagesData, ListMessagesResponses, DownloadMessagesData, DownloadMessagesResponses, ListErrorsData, ListErrorsResponses, DownloadErrorExportData, DownloadErrorExportResponses, ListAdaptersData, ListAdaptersResponses, Health1Data, Health1Responses, PerformanceData, PerformanceResponses, MetricsData, MetricsResponses, ErrorsData, ErrorsResponses, List1Data, List1Responses, QueryData, QueryResponses, GetMobileLocationStatisticsData, GetMobileLocationStatisticsResponses, GetRealtimeStats1Data, GetRealtimeStats1Responses, GetDashboardOverviewData, GetDashboardOverviewResponses, GetAlertsData, GetAlertsResponses, StatusData, StatusResponses, GetChannelStatusListData, GetChannelStatusListResponses, GetChannelPerformance1Data, GetChannelPerformance1Responses, RemoveFromWhitelistData, RemoveFromWhitelistResponses, RemoveFromBlacklistData, RemoveFromBlacklistResponses, DeleteWhitelistData, DeleteWhitelistResponses, DeleteSensitiveWordData, DeleteSensitiveWordResponses, DeleteBlacklistData, DeleteBlacklistResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 删除用户
 * 删除用户及其相关数据
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteUserResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/{userId}',
        ...options
    });
};

/**
 * 获取用户详情
 * 根据用户ID获取用户详细信息
 */
export const getUserById = <ThrowOnError extends boolean = false>(options: Options<GetUserByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/{userId}',
        ...options
    });
};

/**
 * 更新用户
 * 更新用户信息和角色
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateUserResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除Webhook
 */
export const tenantDeleteWebhook = <ThrowOnError extends boolean = false>(options: Options<TenantDeleteWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TenantDeleteWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks/{id}',
        ...options
    });
};

/**
 * 获取Webhook详情
 */
export const tenantGetWebhook = <ThrowOnError extends boolean = false>(options: Options<TenantGetWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantGetWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks/{id}',
        ...options
    });
};

/**
 * 更新Webhook
 */
export const tenantUpdateWebhook = <ThrowOnError extends boolean = false>(options: Options<TenantUpdateWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TenantUpdateWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteMyTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteMyTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMyTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/templates/{id}',
        ...options
    });
};

export const getMyTemplateById = <ThrowOnError extends boolean = false>(options: Options<GetMyTemplateByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMyTemplateByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/templates/{id}',
        ...options
    });
};

export const updateMyTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateMyTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateMyTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteMySignature = <ThrowOnError extends boolean = false>(options: Options<DeleteMySignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMySignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures/{id}',
        ...options
    });
};

export const getMySignatureById = <ThrowOnError extends boolean = false>(options: Options<GetMySignatureByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMySignatureByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures/{id}',
        ...options
    });
};

export const updateMySignature = <ThrowOnError extends boolean = false>(options: Options<UpdateMySignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateMySignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新租户设置某一节
 */
export const updateSection = <ThrowOnError extends boolean = false>(options: Options<UpdateSectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSectionResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/settings/{section}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户信息
 * 获取当前租户的基本信息
 */
export const tenantGetProfile = <ThrowOnError extends boolean = false>(options?: Options<TenantGetProfileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile',
        ...options
    });
};

/**
 * 更新租户信息
 * 更新租户基本信息
 */
export const tenantUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<TenantUpdateProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TenantUpdateProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除API Key
 * 删除指定的API Key
 */
export const tenantProfileDeleteApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantProfileDeleteApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TenantProfileDeleteApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys/{keyId}',
        ...options
    });
};

/**
 * 更新API Key
 * 更新API Key的配置
 */
export const tenantProfileUpdateApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantProfileUpdateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TenantProfileUpdateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys/{keyId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getAdminProfile = <ThrowOnError extends boolean = false>(options?: Options<GetAdminProfileData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAdminProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/admin-profile',
        ...options
    });
};

export const updateAdminProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateAdminProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateAdminProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/admin-profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除API Key
 */
export const tenantDeleteApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantDeleteApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TenantDeleteApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys/{id}',
        ...options
    });
};

/**
 * 获取API Key详情
 */
export const tenantGetApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantGetApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantGetApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys/{id}',
        ...options
    });
};

/**
 * 更新API Key
 */
export const tenantUpdateApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantUpdateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TenantUpdateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新API Key状态
 */
export const tenantUpdateApiKeyStatus = <ThrowOnError extends boolean = false>(options: Options<TenantUpdateApiKeyStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<TenantUpdateApiKeyStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除用户
 * 删除用户（软删除）
 */
export const deleteUser1 = <ThrowOnError extends boolean = false>(options: Options<DeleteUser1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteUser1Responses, DeleteUser1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}',
        ...options
    });
};

/**
 * 用户详情
 * 获取指定用户的详细信息
 */
export const getUserDetail = <ThrowOnError extends boolean = false>(options: Options<GetUserDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserDetailResponses, GetUserDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}',
        ...options
    });
};

/**
 * 更新用户
 * 更新用户信息
 */
export const updateUser1 = <ThrowOnError extends boolean = false>(options: Options<UpdateUser1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateUser1Responses, UpdateUser1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新用户状态
 * 更新用户的状态 (ACTIVE, INACTIVE, LOCKED)
 */
export const updateUserStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateUserStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateUserStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取用户角色
 * 获取指定用户的角色列表
 */
export const getUserRoles = <ThrowOnError extends boolean = false>(options: Options<GetUserRolesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUserRolesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}/roles',
        ...options
    });
};

/**
 * 分配用户角色
 * 为指定用户分配角色
 */
export const assignUserRoles = <ThrowOnError extends boolean = false>(options: Options<AssignUserRolesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AssignUserRolesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}/roles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新租户状态
 * 启用/禁用租户
 */
export const updateTenantStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateTenantStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateTenantStatusResponses, UpdateTenantStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新租户认证状态
 * 管理员维护：更新租户的企业认证状态（NOT_SUBMITTED/PENDING/VERIFIED/REJECTED）
 */
export const adminUpdateCertificationStatus = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateCertificationStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdminUpdateCertificationStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/certification/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新API Key状态
 * 管理员强制禁用或启用API Key
 */
export const updateApiKeyStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateApiKeyStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateApiKeyStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/api-keys/{keyId}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新签名状态
 * 更新签名的状态
 */
export const updateSignatureStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateSignatureStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSignatureStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新指定运营商报备状态
 * 更新指定运营商的报备状态
 */
export const updateSpecificOperatorReport = <ThrowOnError extends boolean = false>(options: Options<UpdateSpecificOperatorReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSpecificOperatorReportResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}/operator-reports/{operatorCode}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 更新运营商报备状态
 * 更新签名的运营商报备状态
 */
export const updateOperatorReportStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateOperatorReportStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateOperatorReportStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}/operator-report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除路由规则
 */
export const delete_ = <ThrowOnError extends boolean = false>(options: Options<DeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/routing/rules/{id}',
        ...options
    });
};

/**
 * 获取路由规则详情
 */
export const getById = <ThrowOnError extends boolean = false>(options: Options<GetByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/routing/rules/{id}',
        ...options
    });
};

/**
 * 更新路由规则
 */
export const update = <ThrowOnError extends boolean = false>(options: Options<UpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/routing/rules/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取协议配置
 */
export const getProtocolConfig = <ThrowOnError extends boolean = false>(options: Options<GetProtocolConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProtocolConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/{protocol}/config',
        ...options
    });
};

/**
 * 更新协议配置
 */
export const updateProtocolConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateProtocolConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateProtocolConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/{protocol}/config',
        ...options
    });
};

/**
 * 删除号段
 * 删除号段归属地信息
 */
export const deleteMobileLocation = <ThrowOnError extends boolean = false>(options: Options<DeleteMobileLocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMobileLocationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations/{locationId}',
        ...options
    });
};

/**
 * 更新号段
 * 修改号段归属地信息
 */
export const updateMobileLocation = <ThrowOnError extends boolean = false>(options: Options<UpdateMobileLocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateMobileLocationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations/{locationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除频次限制规则
 */
export const deleteFrequencyRule = <ThrowOnError extends boolean = false>(options: Options<DeleteFrequencyRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteFrequencyRuleResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/frequency-rules/{id}',
        ...options
    });
};

/**
 * 更新频次限制规则
 */
export const updateFrequencyRule = <ThrowOnError extends boolean = false>(options: Options<UpdateFrequencyRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateFrequencyRuleResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/frequency-rules/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteKeyword = <ThrowOnError extends boolean = false>(options: Options<DeleteKeywordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteKeywordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/content-audit/keywords/{id}',
        ...options
    });
};

export const updateKeyword = <ThrowOnError extends boolean = false>(options: Options<UpdateKeywordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateKeywordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/content-audit/keywords/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除通道
 * 删除指定通道
 */
export const deleteChannel = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}',
        ...options
    });
};

/**
 * 获取通道详情
 * 根据ID获取通道详细信息
 */
export const getChannel = <ThrowOnError extends boolean = false>(options: Options<GetChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}',
        ...options
    });
};

/**
 * 更新通道
 * 更新通道配置信息
 */
export const updateChannel = <ThrowOnError extends boolean = false>(options: Options<UpdateChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 分页查询用户
 * 根据条件分页查询用户列表
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users',
        ...options
    });
};

/**
 * 创建用户
 * 创建新用户并分配角色
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUserResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 锁定/解锁用户
 * 切换用户的锁定状态
 */
export const toggleUserLock = <ThrowOnError extends boolean = false>(options: Options<ToggleUserLockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ToggleUserLockResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/{userId}/toggle-lock',
        ...options
    });
};

/**
 * 重置用户密码
 * 重置指定用户的密码
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetPasswordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/{userId}/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getWhitelist = <ThrowOnError extends boolean = false>(options?: Options<GetWhitelistData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/whitelist',
        ...options
    });
};

export const addToWhitelist = <ThrowOnError extends boolean = false>(options: Options<AddToWhitelistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddToWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/whitelist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const batchAddToWhitelist = <ThrowOnError extends boolean = false>(options: Options<BatchAddToWhitelistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BatchAddToWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/whitelist/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 查询Webhook列表
 */
export const tenantGetWebhooks = <ThrowOnError extends boolean = false>(options?: Options<TenantGetWebhooksData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetWebhooksResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks',
        ...options
    });
};

/**
 * 创建Webhook
 */
export const tenantCreateWebhook = <ThrowOnError extends boolean = false>(options: Options<TenantCreateWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantCreateWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 测试Webhook
 */
export const tenantTestWebhook = <ThrowOnError extends boolean = false>(options: Options<TenantTestWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantTestWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhooks/{id}/test',
        ...options
    });
};

export const getMyTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetMyTemplatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMyTemplatesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/templates',
        ...options
    });
};

export const createMyTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateMyTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMyTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出上行短信
 */
export const exportUplink = <ThrowOnError extends boolean = false>(options?: Options<ExportUplinkData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportUplinkResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/uplink/export',
        ...options
    });
};

/**
 * 发送测试短信
 * 租户在管理后台发送测试短信
 */
export const tenantSendSms = <ThrowOnError extends boolean = false>(options: Options<TenantSendSmsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantSendSmsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出短信记录
 * 发起导出任务并返回导出ID
 */
export const tenantExportSmsRecords = <ThrowOnError extends boolean = false>(options?: Options<TenantExportSmsRecordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TenantExportSmsRecordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/records/export',
        ...options
    });
};

export const getMySignatures = <ThrowOnError extends boolean = false>(options?: Options<GetMySignaturesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMySignaturesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures',
        ...options
    });
};

export const createMySignature = <ThrowOnError extends boolean = false>(options: Options<CreateMySignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMySignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 提交企业认证
 * 租户提交企业认证申请
 */
export const tenantSubmitCertification = <ThrowOnError extends boolean = false>(options: Options<TenantSubmitCertificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantSubmitCertificationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/certification/submit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * API Key列表
 * 获取租户的API Key列表
 */
export const tenantProfileGetApiKeys = <ThrowOnError extends boolean = false>(options?: Options<TenantProfileGetApiKeysData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantProfileGetApiKeysResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys',
        ...options
    });
};

/**
 * 创建API Key
 * 为租户创建新的API Key
 */
export const tenantProfileCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantProfileCreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantProfileCreateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 重新生成API Key
 * 重新生成指定API Key的密钥
 */
export const tenantProfileRegenerateApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantProfileRegenerateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantProfileRegenerateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys/{keyId}/regenerate',
        ...options
    });
};

export const checkContent = <ThrowOnError extends boolean = false>(options: Options<CheckContentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckContentResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/content-audit/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getBlacklist = <ThrowOnError extends boolean = false>(options?: Options<GetBlacklistData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/blacklist',
        ...options
    });
};

export const addToBlacklist = <ThrowOnError extends boolean = false>(options: Options<AddToBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddToBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/blacklist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const batchAddToBlacklist = <ThrowOnError extends boolean = false>(options: Options<BatchAddToBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BatchAddToBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/blacklist/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出费用明细CSV（MVP，最多1000条）
 */
export const exportBilling = <ThrowOnError extends boolean = false>(options?: Options<ExportBillingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportBillingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/billing/records/export',
        ...options
    });
};

/**
 * 查询API Key列表
 */
export const tenantGetApiKeys = <ThrowOnError extends boolean = false>(options?: Options<TenantGetApiKeysData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetApiKeysResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys',
        ...options
    });
};

/**
 * 创建API Key
 */
export const tenantCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<TenantCreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantCreateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户自助充值
 * 租户发起充值请求（MOCK版本）
 */
export const selfRecharge = <ThrowOnError extends boolean = false>(options: Options<SelfRechargeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SelfRechargeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/account/recharge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 发送短信
 * 发送单条短信
 */
export const sendSms = <ThrowOnError extends boolean = false>(options: Options<SendSmsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendSmsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 批量查询短信状态
 * 批量查询多条短信的发送状态
 */
export const queryBatchSmsStatus = <ThrowOnError extends boolean = false>(options: Options<QueryBatchSmsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryBatchSmsStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/query/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 取消发送
 * 取消未发送的短信
 */
export const cancelSms = <ThrowOnError extends boolean = false>(options: Options<CancelSmsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelSmsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/cancel/{messageId}',
        ...options
    });
};

/**
 * 批量发送
 * 批量发送短信
 */
export const batchSendSms = <ThrowOnError extends boolean = false>(options: Options<BatchSendSmsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BatchSendSmsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 分页查询角色
 * 根据条件分页查询角色列表
 */
export const getRoles = <ThrowOnError extends boolean = false>(options?: Options<GetRolesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRolesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/roles',
        ...options
    });
};

/**
 * 创建角色
 * 创建新角色并分配权限
 */
export const createRole = <ThrowOnError extends boolean = false>(options: Options<CreateRoleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRoleResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/roles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户注册
 * 企业用户自助注册租户账号
 */
export const registerTenant = <ThrowOnError extends boolean = false>(options: Options<RegisterTenantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegisterTenantResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/public/tenant/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 验证API Key
 * 验证客户端API Key的有效性
 */
export const validateApiKey = <ThrowOnError extends boolean = false>(options?: Options<ValidateApiKeyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ValidateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/validate-api-key',
        ...options
    });
};

export const validateApiKeyWithSignature = <ThrowOnError extends boolean = false>(options: Options<ValidateApiKeyWithSignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ValidateApiKeyWithSignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/validate-api-key-with-signature',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 记录API Key使用
 * 记录API Key的使用情况
 */
export const recordApiKeyUsage = <ThrowOnError extends boolean = false>(options: Options<RecordApiKeyUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordApiKeyUsageResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/api-key-usage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户注册（账号+密码）
 * 创建租户与初始管理员账号并返回token
 */
export const tenantRegister = <ThrowOnError extends boolean = false>(options: Options<TenantRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantRegisterResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/tenant/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户登录
 * 租户用户登录接口
 */
export const tenantLogin = <ThrowOnError extends boolean = false>(options: Options<TenantLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantLoginResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/tenant/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 刷新Token
 * 使用refresh token获取新的access token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 登出
 * 用户登出，使token失效
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LogoutResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/logout',
        ...options
    });
};

/**
 * 管理员登录
 * 平台管理员登录接口
 */
export const adminLogin = <ThrowOnError extends boolean = false>(options: Options<AdminLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminLoginResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/admin/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取白名单列表
 */
export const getWhitelist1 = <ThrowOnError extends boolean = false>(options?: Options<GetWhitelist1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetWhitelist1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/whitelist',
        ...options
    });
};

/**
 * 添加白名单
 */
export const addWhitelist = <ThrowOnError extends boolean = false>(options: Options<AddWhitelistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/whitelist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 用户列表
 * 获取平台所有用户列表
 */
export const getUsers1 = <ThrowOnError extends boolean = false>(options?: Options<GetUsers1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUsers1Responses, GetUsers1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users',
        ...options
    });
};

/**
 * 创建用户
 * 创建新的用户
 */
export const createUser1 = <ThrowOnError extends boolean = false>(options: Options<CreateUser1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUser1Responses, CreateUser1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 锁定/解锁用户
 * 切换用户的锁定状态
 */
export const toggleUserLock1 = <ThrowOnError extends boolean = false>(options: Options<ToggleUserLock1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ToggleUserLock1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}/toggle-lock',
        ...options
    });
};

/**
 * 重置密码
 * 管理员重置用户密码
 */
export const resetPassword1 = <ThrowOnError extends boolean = false>(options: Options<ResetPassword1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetPassword1Responses, ResetPassword1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{userId}/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户列表
 * 获取平台所有租户列表
 */
export const getTenants = <ThrowOnError extends boolean = false>(options?: Options<GetTenantsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTenantsResponses, GetTenantsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants',
        ...options
    });
};

/**
 * 创建租户
 * 创建新的租户
 */
export const createTenant = <ThrowOnError extends boolean = false>(options: Options<CreateTenantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTenantResponses, CreateTenantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 租户充值
 * 为租户账户充值
 */
export const rechargeTenant = <ThrowOnError extends boolean = false>(options: Options<RechargeTenantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RechargeTenantResponses, RechargeTenantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/recharge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 管理员代替租户提交认证
 * 管理员代替租户提交企业认证申请（测试用）
 */
export const submitCertificationForTenant = <ThrowOnError extends boolean = false>(options: Options<SubmitCertificationForTenantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitCertificationForTenantResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/certification/submit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 审核企业认证
 * 审核租户的企业认证申请
 */
export const approveCertification = <ThrowOnError extends boolean = false>(options: Options<ApproveCertificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveCertificationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/certification/approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 审核租户
 * 审核通过或拒绝租户申请
 */
export const approveTenant = <ThrowOnError extends boolean = false>(options: Options<ApproveTenantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveTenantResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 创建租户（审核流程）
 * 创建租户并进入审核流程
 */
export const createTenantWithApproval = <ThrowOnError extends boolean = false>(options: Options<CreateTenantWithApprovalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTenantWithApprovalResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/with-approval',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const reviewTemplate = <ThrowOnError extends boolean = false>(options: Options<ReviewTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/templates/{id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 审核签名
 * 审核一个待处理的签名
 */
export const reviewSignature = <ThrowOnError extends boolean = false>(options: Options<ReviewSignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewSignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取敏感词列表
 */
export const getSensitiveWords = <ThrowOnError extends boolean = false>(options?: Options<GetSensitiveWordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSensitiveWordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/sensitive-words',
        ...options
    });
};

/**
 * 添加敏感词
 */
export const addSensitiveWord = <ThrowOnError extends boolean = false>(options: Options<AddSensitiveWordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddSensitiveWordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/sensitive-words',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 批量导入敏感词
 */
export const batchImportSensitiveWords = <ThrowOnError extends boolean = false>(options?: Options<BatchImportSensitiveWordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<BatchImportSensitiveWordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/sensitive-words/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 分页查询路由规则
 */
export const list = <ThrowOnError extends boolean = false>(options?: Options<ListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/routing/rules',
        ...options
    });
};

/**
 * 创建路由规则
 */
export const create = <ThrowOnError extends boolean = false>(options: Options<CreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/routing/rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出上行短信CSV（MVP，最多1000条）
 */
export const exportUplink1 = <ThrowOnError extends boolean = false>(options?: Options<ExportUplink1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportUplink1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/uplink/export',
        ...options
    });
};

/**
 * 注入上行记录（测试用）
 */
export const ingestUplink = <ThrowOnError extends boolean = false>(options: Options<IngestUplinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestUplinkResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/uplink/_ingest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 注入上行记录（测试用）
 */
export const ingestUplink1 = <ThrowOnError extends boolean = false>(options: Options<IngestUplink1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestUplink1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/uplink/ingest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出回执CSV（MVP，最多1000条）
 */
export const exportReceipts = <ThrowOnError extends boolean = false>(options?: Options<ExportReceiptsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportReceiptsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/receipts/export',
        ...options
    });
};

/**
 * 注入回执（测试用）
 */
export const ingestReceipt = <ThrowOnError extends boolean = false>(options: Options<IngestReceiptData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestReceiptResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/receipts/_ingest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 注入回执（测试用）
 */
export const ingestReceipt1 = <ThrowOnError extends boolean = false>(options: Options<IngestReceipt1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestReceipt1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/receipts/ingest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 导出短信详单
 */
export const exportMessages = <ThrowOnError extends boolean = false>(options?: Options<ExportMessagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportMessagesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/messages/export',
        ...options
    });
};

/**
 * 导出错误详单CSV
 */
export const exportErrors = <ThrowOnError extends boolean = false>(options?: Options<ExportErrorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ExportErrorsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/errors/export',
        ...options
    });
};

/**
 * 导入携号转网CSV
 */
export const importCsv = <ThrowOnError extends boolean = false>(options?: Options<ImportCsvData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ImportCsvResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/portability/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 号段列表
 * 获取所有号段归属地信息
 */
export const getMobileLocations = <ThrowOnError extends boolean = false>(options?: Options<GetMobileLocationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMobileLocationsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations',
        ...options
    });
};

/**
 * 创建号段
 * 新增号段归属地信息
 */
export const createMobileLocation = <ThrowOnError extends boolean = false>(options: Options<CreateMobileLocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMobileLocationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 号码归属查询
 * 查询手机号码的归属地信息
 */
export const queryMobileLocation = <ThrowOnError extends boolean = false>(options: Options<QueryMobileLocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryMobileLocationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations/query',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 批量导入
 * 从文件批量导入号段数据
 */
export const importMobileLocations = <ThrowOnError extends boolean = false>(options?: Options<ImportMobileLocationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ImportMobileLocationsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * 获取频次限制规则列表
 */
export const getFrequencyRules = <ThrowOnError extends boolean = false>(options?: Options<GetFrequencyRulesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFrequencyRulesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/frequency-rules',
        ...options
    });
};

/**
 * 创建频次限制规则
 */
export const createFrequencyRule = <ThrowOnError extends boolean = false>(options: Options<CreateFrequencyRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFrequencyRuleResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/frequency-rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getKeywords = <ThrowOnError extends boolean = false>(options?: Options<GetKeywordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetKeywordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/content-audit/keywords',
        ...options
    });
};

export const addKeyword = <ThrowOnError extends boolean = false>(options: Options<AddKeywordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddKeywordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/content-audit/keywords',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const checkContent1 = <ThrowOnError extends boolean = false>(options: Options<CheckContent1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckContent1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/content-audit/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 分页查询通道
 * 分页查询通道列表
 */
export const getChannelPage = <ThrowOnError extends boolean = false>(options?: Options<GetChannelPageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetChannelPageResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels',
        ...options
    });
};

/**
 * 创建通道
 * 创建新的短信通道
 */
export const createChannel = <ThrowOnError extends boolean = false>(options: Options<CreateChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 测试通道
 * 测试通道连通性和性能
 */
export const testChannel = <ThrowOnError extends boolean = false>(options: Options<TestChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TestChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}/test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 启用通道
 * 启用指定通道
 */
export const enableChannel = <ThrowOnError extends boolean = false>(options: Options<EnableChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnableChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}/enable',
        ...options
    });
};

/**
 * 禁用通道
 * 禁用指定通道
 */
export const disableChannel = <ThrowOnError extends boolean = false>(options: Options<DisableChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DisableChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/{channelId}/disable',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 通道选择
 * 根据条件选择最佳通道
 */
export const selectChannel = <ThrowOnError extends boolean = false>(options: Options<SelectChannelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SelectChannelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/select',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取黑名单列表
 */
export const getBlacklist1 = <ThrowOnError extends boolean = false>(options?: Options<GetBlacklist1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBlacklist1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/blacklist',
        ...options
    });
};

/**
 * 添加黑名单
 */
export const addBlacklist = <ThrowOnError extends boolean = false>(options: Options<AddBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/blacklist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取用户统计信息
 * 获取用户相关的统计数据
 */
export const getUserStatistics = <ThrowOnError extends boolean = false>(options?: Options<GetUserStatisticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUserStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/statistics',
        ...options
    });
};

/**
 * 获取当前用户信息
 * 获取当前登录用户的详细信息
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCurrentUserResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/me',
        ...options
    });
};

/**
 * 获取Webhook集成指南
 */
export const tenantGetWebhookIntegrationGuide = <ThrowOnError extends boolean = false>(options?: Options<TenantGetWebhookIntegrationGuideData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetWebhookIntegrationGuideResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhook-docs/integration-guide',
        ...options
    });
};

/**
 * 获取所有支持的事件类型
 */
export const tenantGetWebhookEvents = <ThrowOnError extends boolean = false>(options?: Options<TenantGetWebhookEventsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetWebhookEventsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhook-docs/events',
        ...options
    });
};

/**
 * 获取事件类型分类
 */
export const tenantGetWebhookCategories = <ThrowOnError extends boolean = false>(options?: Options<TenantGetWebhookCategoriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetWebhookCategoriesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/webhook-docs/categories',
        ...options
    });
};

/**
 * 查询上行短信
 */
export const listUplink = <ThrowOnError extends boolean = false>(options?: Options<ListUplinkData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUplinkResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/uplink',
        ...options
    });
};

/**
 * 短信发送统计
 */
export const stats = <ThrowOnError extends boolean = false>(options: Options<StatsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StatsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/statistics',
        ...options
    });
};

/**
 * 查询发送记录
 * 查询租户的短信发送记录
 */
export const tenantGetSmsRecords = <ThrowOnError extends boolean = false>(options?: Options<TenantGetSmsRecordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetSmsRecordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/records',
        ...options
    });
};

/**
 * 查询短信状态
 * 根据消息ID查询短信状态
 */
export const tenantGetSmsStatus = <ThrowOnError extends boolean = false>(options: Options<TenantGetSmsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantGetSmsStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/records/{messageId}',
        ...options
    });
};

/**
 * 下载短信记录CSV
 */
export const tenantDownloadSmsExport = <ThrowOnError extends boolean = false>(options: Options<TenantDownloadSmsExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantDownloadSmsExportResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/sms/records/export/{exportId}/download',
        ...options
    });
};

export const getApprovedSignatures = <ThrowOnError extends boolean = false>(options?: Options<GetApprovedSignaturesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApprovedSignaturesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/signatures/approved',
        ...options
    });
};

/**
 * 获取租户设置
 */
export const getSettings = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSettingsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/settings',
        ...options
    });
};

/**
 * 区间统计（折线图）
 */
export const range = <ThrowOnError extends boolean = false>(options: Options<RangeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RangeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/reports',
        ...options
    });
};

/**
 * 月度报表
 */
export const monthly = <ThrowOnError extends boolean = false>(options: Options<MonthlyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MonthlyResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/reports/monthly',
        ...options
    });
};

/**
 * 使用统计
 * 获取租户的短信发送统计信息
 */
export const tenantGetStatistics = <ThrowOnError extends boolean = false>(options?: Options<TenantGetStatisticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/statistics',
        ...options
    });
};

/**
 * 获取企业认证信息
 * 获取当前租户的企业认证信息
 */
export const tenantGetCertification = <ThrowOnError extends boolean = false>(options?: Options<TenantGetCertificationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetCertificationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/certification',
        ...options
    });
};

export const getCertificationRejectionReasons = <ThrowOnError extends boolean = false>(options?: Options<GetCertificationRejectionReasonsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCertificationRejectionReasonsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/certification/rejection-reasons',
        ...options
    });
};

/**
 * 账户余额
 * 获取当前租户的账户余额信息
 */
export const tenantGetBalance = <ThrowOnError extends boolean = false>(options?: Options<TenantGetBalanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetBalanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/balance',
        ...options
    });
};

/**
 * API Key使用统计
 * 获取指定API Key的使用统计
 */
export const tenantProfileGetApiKeyStatistics = <ThrowOnError extends boolean = false>(options: Options<TenantProfileGetApiKeyStatisticsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantProfileGetApiKeyStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/profile/api-keys/{keyId}/statistics',
        ...options
    });
};

/**
 * 查询上行消息列表
 */
export const tenantGetMoMessages = <ThrowOnError extends boolean = false>(options?: Options<TenantGetMoMessagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetMoMessagesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/mo-messages',
        ...options
    });
};

/**
 * 获取上行消息详情
 */
export const tenantGetMoMessage = <ThrowOnError extends boolean = false>(options: Options<TenantGetMoMessageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantGetMoMessageResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/mo-messages/{id}',
        ...options
    });
};

/**
 * 获取上行消息统计
 */
export const tenantGetMoMessageStats = <ThrowOnError extends boolean = false>(options?: Options<TenantGetMoMessageStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantGetMoMessageStatsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/mo-messages/stats',
        ...options
    });
};

export const checkBlacklist = <ThrowOnError extends boolean = false>(options: Options<CheckBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/blacklist/check',
        ...options
    });
};

/**
 * 查询费用明细
 */
export const listBillingRecords = <ThrowOnError extends boolean = false>(options?: Options<ListBillingRecordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBillingRecordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/billing/records',
        ...options
    });
};

/**
 * 下载费用明细CSV
 */
export const downloadBilling = <ThrowOnError extends boolean = false>(options: Options<DownloadBillingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadBillingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/billing/records/export/{exportId}/download',
        ...options
    });
};

/**
 * 查询账户余额
 */
export const getBalance = <ThrowOnError extends boolean = false>(options?: Options<GetBalanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBalanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/billing/balance',
        ...options
    });
};

/**
 * 查询交易记录
 * 分页查询账户交易记录
 */
export const getTransactions = <ThrowOnError extends boolean = false>(options?: Options<GetTransactionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTransactionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/account/transactions',
        ...options
    });
};

/**
 * 账户概览
 * 获取账户概览信息
 */
export const getAccountOverview = <ThrowOnError extends boolean = false>(options?: Options<GetAccountOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAccountOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/account/overview',
        ...options
    });
};

/**
 * 查询账户余额
 */
export const tenantAccountBalance = <ThrowOnError extends boolean = false>(options?: Options<TenantAccountBalanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantAccountBalanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/account/balance',
        ...options
    });
};

/**
 * 模板列表
 * 获取租户可用的短信模板列表
 */
export const getTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetTemplatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTemplatesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/templates',
        ...options
    });
};

/**
 * 模板详情
 * 获取指定模板的详细信息
 */
export const getTemplateDetail = <ThrowOnError extends boolean = false>(options: Options<GetTemplateDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateDetailResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/templates/{templateCode}',
        ...options
    });
};

/**
 * 查询状态
 * 查询短信发送状态
 */
export const getSmsStatus = <ThrowOnError extends boolean = false>(options: Options<GetSmsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSmsStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/status/{messageId}',
        ...options
    });
};

/**
 * 发送记录
 * 查询短信发送记录
 */
export const getSmsRecords = <ThrowOnError extends boolean = false>(options?: Options<GetSmsRecordsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSmsRecordsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/records',
        ...options
    });
};

/**
 * 查询短信状态
 * 根据messageId查询短信发送状态
 */
export const querySmsStatus = <ThrowOnError extends boolean = false>(options: Options<QuerySmsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<QuerySmsStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/sms/query/{messageId}',
        ...options
    });
};

/**
 * 获取所有权限
 * 获取系统中所有可用的权限
 */
export const getAllPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetAllPermissionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllPermissionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/roles/permissions',
        ...options
    });
};

/**
 * 检查联系电话
 * 检查联系电话是否已被使用
 */
export const checkContactPhone = <ThrowOnError extends boolean = false>(options: Options<CheckContactPhoneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckContactPhoneResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/public/tenant/check-phone',
        ...options
    });
};

/**
 * 检查联系邮箱
 * 检查联系邮箱是否已被使用
 */
export const checkContactEmail = <ThrowOnError extends boolean = false>(options: Options<CheckContactEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckContactEmailResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/public/tenant/check-email',
        ...options
    });
};

/**
 * 检查租户编码
 * 检查租户编码是否已被使用
 */
export const checkTenantCode = <ThrowOnError extends boolean = false>(options: Options<CheckTenantCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckTenantCodeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/public/tenant/check-code',
        ...options
    });
};

/**
 * 获取API Key信息
 * 获取API Key的详细信息和权限
 */
export const getApiKeyInfo = <ThrowOnError extends boolean = false>(options: Options<GetApiKeyInfoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiKeyInfoResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/internal/api-key-info',
        ...options
    });
};

/**
 * 基础健康检查
 * 检查服务基本状态
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/health',
        ...options
    });
};

/**
 * 详细健康检查
 * 检查数据库、Redis等组件状态
 */
export const detailedHealth = <ThrowOnError extends boolean = false>(options?: Options<DetailedHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DetailedHealthResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/health/detailed',
        ...options
    });
};

export const getFile = <ThrowOnError extends boolean = false>(options: Options<GetFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFileResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{objectKey}',
        ...options
    });
};

/**
 * 验证Token
 * 验证当前token是否有效
 */
export const validateToken = <ThrowOnError extends boolean = false>(options?: Options<ValidateTokenData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ValidateTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/validate',
        ...options
    });
};

/**
 * 获取当前用户信息
 * 获取当前登录用户的详细信息
 */
export const getCurrentUser1 = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUser1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCurrentUser1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/auth/me',
        ...options
    });
};

/**
 * 用户统计
 * 获取用户统计信息
 */
export const getUserStatistics1 = <ThrowOnError extends boolean = false>(options?: Options<GetUserStatistics1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUserStatistics1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/statistics',
        ...options
    });
};

/**
 * 租户详情
 * 获取指定租户的详细信息
 */
export const getTenantDetail = <ThrowOnError extends boolean = false>(options: Options<GetTenantDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTenantDetailResponses, GetTenantDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}',
        ...options
    });
};

/**
 * 获取租户认证信息
 * 获取指定租户的企业认证信息
 */
export const getTenantCertification = <ThrowOnError extends boolean = false>(options: Options<GetTenantCertificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTenantCertificationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/certification',
        ...options
    });
};

/**
 * 获取认证拒绝原因
 * 获取租户认证被拒绝的详细原因
 */
export const getCertificationRejectionReasons1 = <ThrowOnError extends boolean = false>(options: Options<GetCertificationRejectionReasons1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCertificationRejectionReasons1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/certification/rejection-reasons',
        ...options
    });
};

/**
 * 租户审核历史
 * 获取指定租户的审核历史记录
 */
export const getTenantApprovalHistory = <ThrowOnError extends boolean = false>(options: Options<GetTenantApprovalHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTenantApprovalHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/approval-history',
        ...options
    });
};

/**
 * 租户API Key列表
 * 管理员查看租户的API Key列表
 */
export const getTenantApiKeys = <ThrowOnError extends boolean = false>(options: Options<GetTenantApiKeysData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTenantApiKeysResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/api-keys',
        ...options
    });
};

/**
 * 获取租户账户信息
 * 获取指定租户的账户余额和统计信息
 */
export const getTenantAccount = <ThrowOnError extends boolean = false>(options: Options<GetTenantAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTenantAccountResponses, GetTenantAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/{tenantId}/account',
        ...options
    });
};

/**
 * 待审核租户列表
 * 获取所有待审核的租户
 */
export const getPendingApprovalTenants = <ThrowOnError extends boolean = false>(options?: Options<GetPendingApprovalTenantsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPendingApprovalTenantsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/pending-approval',
        ...options
    });
};

/**
 * 所有待审核记录
 * 获取平台所有待审核的记录
 */
export const getAllPendingApprovals = <ThrowOnError extends boolean = false>(options?: Options<GetAllPendingApprovalsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllPendingApprovalsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/approvals/pending',
        ...options
    });
};

/**
 * 平台API Key统计
 * 获取平台所有API Key的使用统计
 */
export const getPlatformApiKeyStatistics = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformApiKeyStatisticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPlatformApiKeyStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/tenants/api-keys/statistics',
        ...options
    });
};

export const getTemplates1 = <ThrowOnError extends boolean = false>(options?: Options<GetTemplates1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTemplates1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/templates',
        ...options
    });
};

export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/templates/{id}',
        ...options
    });
};

export const getTemplateById = <ThrowOnError extends boolean = false>(options: Options<GetTemplateByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/templates/{id}',
        ...options
    });
};

/**
 * 发送趋势
 * 获取发送趋势数据
 */
export const getSendTrends = <ThrowOnError extends boolean = false>(options?: Options<GetSendTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSendTrendsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/send/trends',
        ...options
    });
};

/**
 * 租户排行
 * 获取租户发送量排行
 */
export const getTenantRanking = <ThrowOnError extends boolean = false>(options?: Options<GetTenantRankingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTenantRankingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/send/tenant-ranking',
        ...options
    });
};

/**
 * 发送统计概览
 * 获取发送统计数据概览
 */
export const getSendStatsOverview = <ThrowOnError extends boolean = false>(options?: Options<GetSendStatsOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSendStatsOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/send/overview',
        ...options
    });
};

/**
 * 通道性能
 * 获取通道性能统计
 */
export const getChannelPerformance = <ThrowOnError extends boolean = false>(options?: Options<GetChannelPerformanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetChannelPerformanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/send/channel-performance',
        ...options
    });
};

/**
 * 收入趋势
 * 获取收入趋势数据
 */
export const getRevenueTrends = <ThrowOnError extends boolean = false>(options?: Options<GetRevenueTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRevenueTrendsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/revenue/trends',
        ...options
    });
};

/**
 * 收入统计概览
 * 获取收入统计数据概览
 */
export const getRevenueStatsOverview = <ThrowOnError extends boolean = false>(options?: Options<GetRevenueStatsOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRevenueStatsOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/revenue/overview',
        ...options
    });
};

/**
 * 实时统计
 * 获取实时统计数据
 */
export const getRealtimeStats = <ThrowOnError extends boolean = false>(options?: Options<GetRealtimeStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRealtimeStatsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/realtime',
        ...options
    });
};

/**
 * 平台概览
 * 获取平台整体统计概览
 */
export const getPlatformOverview = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPlatformOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/statistics/platform/overview',
        ...options
    });
};

/**
 * 查询签名列表
 * 分页查询、筛选所有签名
 */
export const getSignatures = <ThrowOnError extends boolean = false>(options?: Options<GetSignaturesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSignaturesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures',
        ...options
    });
};

/**
 * 删除签名
 * 软删除一个签名
 */
export const deleteSignature = <ThrowOnError extends boolean = false>(options: Options<DeleteSignatureData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSignatureResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}',
        ...options
    });
};

/**
 * 获取签名详情
 * 根据ID获取单个签名的详细信息
 */
export const getSignatureById = <ThrowOnError extends boolean = false>(options: Options<GetSignatureByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSignatureByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}',
        ...options
    });
};

/**
 * 获取签名运营商报备详情
 * 获取指定签名的三大运营商报备详情
 */
export const getOperatorReports = <ThrowOnError extends boolean = false>(options: Options<GetOperatorReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorReportsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/{id}/operator-reports',
        ...options
    });
};

/**
 * 获取需要运营商报备的签名
 * 获取平台审核通过但未报备的签名列表
 */
export const getSignaturesNeedingOperatorReporting = <ThrowOnError extends boolean = false>(options?: Options<GetSignaturesNeedingOperatorReportingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSignaturesNeedingOperatorReportingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/operator-reporting/needed',
        ...options
    });
};

/**
 * 获取运营商报备中的签名
 * 获取正在运营商报备中的签名列表
 */
export const getSignaturesInOperatorReporting = <ThrowOnError extends boolean = false>(options?: Options<GetSignaturesInOperatorReportingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSignaturesInOperatorReportingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/signatures/operator-reporting/in-progress',
        ...options
    });
};

/**
 * 获取发送趋势
 * 获取发送趋势数据
 */
export const getSendTrends1 = <ThrowOnError extends boolean = false>(options?: Options<GetSendTrends1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSendTrends1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/send/trends',
        ...options
    });
};

/**
 * 获取发送统计
 * 获取发送统计数据
 */
export const getSendStatistics = <ThrowOnError extends boolean = false>(options?: Options<GetSendStatisticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSendStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/send/statistics',
        ...options
    });
};

/**
 * 获取发送监控数据
 * 获取实时发送监控统计数据
 */
export const getSendMonitoring = <ThrowOnError extends boolean = false>(options?: Options<GetSendMonitoringData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSendMonitoringResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/send/monitoring',
        ...options
    });
};

/**
 * 查询上行短信
 */
export const listUplink1 = <ThrowOnError extends boolean = false>(options?: Options<ListUplink1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUplink1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/uplink',
        ...options
    });
};

/**
 * 下载上行短信CSV
 */
export const downloadUplink = <ThrowOnError extends boolean = false>(options: Options<DownloadUplinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadUplinkResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/uplink/export/{exportId}/download',
        ...options
    });
};

/**
 * 查询回执记录
 */
export const listReceipts = <ThrowOnError extends boolean = false>(options?: Options<ListReceiptsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReceiptsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/receipts',
        ...options
    });
};

/**
 * 下载回执CSV
 */
export const downloadReceipts = <ThrowOnError extends boolean = false>(options: Options<DownloadReceiptsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadReceiptsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/receipts/export/{exportId}/download',
        ...options
    });
};

/**
 * 查询短信详单
 */
export const listMessages = <ThrowOnError extends boolean = false>(options?: Options<ListMessagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMessagesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/messages',
        ...options
    });
};

/**
 * 下载短信详单CSV
 */
export const downloadMessages = <ThrowOnError extends boolean = false>(options: Options<DownloadMessagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadMessagesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/messages/export/{exportId}/download',
        ...options
    });
};

/**
 * 查询错误详单
 */
export const listErrors = <ThrowOnError extends boolean = false>(options?: Options<ListErrorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListErrorsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/errors',
        ...options
    });
};

/**
 * 下载错误详单CSV
 */
export const downloadErrorExport = <ThrowOnError extends boolean = false>(options: Options<DownloadErrorExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadErrorExportResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/records/errors/export/{exportId}',
        ...options
    });
};

/**
 * 查询协议适配器列表
 */
export const listAdapters = <ThrowOnError extends boolean = false>(options?: Options<ListAdaptersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAdaptersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters',
        ...options
    });
};

/**
 * 协议健康检查
 */
export const health1 = <ThrowOnError extends boolean = false>(options: Options<Health1Data, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<Health1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/{protocol}/health',
        ...options
    });
};

/**
 * 协议性能统计
 */
export const performance = <ThrowOnError extends boolean = false>(options?: Options<PerformanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PerformanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/performance',
        ...options
    });
};

/**
 * 协议监控指标
 */
export const metrics = <ThrowOnError extends boolean = false>(options?: Options<MetricsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MetricsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/metrics',
        ...options
    });
};

/**
 * 协议错误统计
 */
export const errors = <ThrowOnError extends boolean = false>(options?: Options<ErrorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ErrorsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/protocol-adapters/errors',
        ...options
    });
};

/**
 * 携号转网分页列表
 */
export const list1 = <ThrowOnError extends boolean = false>(options?: Options<List1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<List1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/portability',
        ...options
    });
};

/**
 * 号码携转查询
 */
export const query = <ThrowOnError extends boolean = false>(options: Options<QueryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<QueryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/portability/query',
        ...options
    });
};

/**
 * 号段统计
 * 获取号段数据统计信息
 */
export const getMobileLocationStatistics = <ThrowOnError extends boolean = false>(options?: Options<GetMobileLocationStatisticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMobileLocationStatisticsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/mobile-locations/statistics',
        ...options
    });
};

/**
 * 实时统计
 * 获取实时发送统计数据
 */
export const getRealtimeStats1 = <ThrowOnError extends boolean = false>(options?: Options<GetRealtimeStats1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRealtimeStats1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/dashboard/realtime',
        ...options
    });
};

/**
 * 仪表板概览
 * 获取平台整体运营数据概览
 */
export const getDashboardOverview = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetDashboardOverviewResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/dashboard/overview',
        ...options
    });
};

/**
 * 告警信息
 * 获取系统告警信息
 */
export const getAlerts = <ThrowOnError extends boolean = false>(options?: Options<GetAlertsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAlertsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/dashboard/alerts',
        ...options
    });
};

/**
 * 连接池状态
 */
export const status = <ThrowOnError extends boolean = false>(options?: Options<StatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/connection-pools/status',
        ...options
    });
};

/**
 * 获取通道状态列表
 * 获取所有通道的运行状态
 */
export const getChannelStatusList = <ThrowOnError extends boolean = false>(options?: Options<GetChannelStatusListData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetChannelStatusListResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/status',
        ...options
    });
};

/**
 * 获取通道性能统计
 * 获取通道性能和使用统计
 */
export const getChannelPerformance1 = <ThrowOnError extends boolean = false>(options?: Options<GetChannelPerformance1Data, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetChannelPerformance1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/channels/performance',
        ...options
    });
};

export const removeFromWhitelist = <ThrowOnError extends boolean = false>(options: Options<RemoveFromWhitelistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveFromWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/whitelist/{id}',
        ...options
    });
};

export const removeFromBlacklist = <ThrowOnError extends boolean = false>(options: Options<RemoveFromBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveFromBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tenant/blacklist/{id}',
        ...options
    });
};

/**
 * 删除白名单
 */
export const deleteWhitelist = <ThrowOnError extends boolean = false>(options: Options<DeleteWhitelistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteWhitelistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/whitelist/{id}',
        ...options
    });
};

/**
 * 删除敏感词
 */
export const deleteSensitiveWord = <ThrowOnError extends boolean = false>(options: Options<DeleteSensitiveWordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSensitiveWordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/sensitive-words/{id}',
        ...options
    });
};

/**
 * 删除黑名单
 */
export const deleteBlacklist = <ThrowOnError extends boolean = false>(options: Options<DeleteBlacklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteBlacklistResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/blacklist/{id}',
        ...options
    });
};